import {
  FETCH_TOEGANGSCONTROLES,
  FETCH_TOEGANGSCONTROLE,
  SAVE_TOEGANGSCONTROLE,
  TOGGLE_TOEGANGSCONTROLE,
  TEST_TOEGANGSCONTROLE,
  START_AUTHORIZATION,
  REFRESH_TOKEN,
  TOEGANGSCONTROLE_ERROR,
  FETCH_DOORSY_RESERVATIONS,
  FETCH_DOORSY_RESERVATION,
  SYNC_DOORSY_RESERVATIONS,
  TEST_DOORSY_CONNECTION,
  FETCH_DOORSY_USER_INFO,
  FETCH_DOORSY_SYSTEM_INFO,
  FETCH_DOORSY_REALESTATES,
  CREATE_DOORSY_REALESTATE,
  DOORSY_ERROR,
  CREATE_TOEGANGSCODE,
  FETCH_TOEGANGSCODES,
  FETCH_TOEGANGSCODE,
  DEACTIVEER_TOEGANGSCODE,
  DELETE_TOEGANGSCODE,
  VALIDATE_TOEGANGSCODE,
  TOEGANGSCODE_ERROR
} from "./types";

const INITIAL_STATE = {
  toegangscontroles: [],
  currentToegangscontrole: null,
  loading: false,
  error: null,
  testResult: null,
  authorizationData: null,
  // Doorsy state
  doorsy: {
    reservations: [],
    currentReservation: null,
    logs: [],
    accessLogs: [],
    auditLogs: [],
    userInfo: null,
    systemInfo: null,
    realestates: [],
    connectionStatus: null,
    syncResult: null,
    loading: false,
    error: null
  },
  // Toegangscode state
  toegangscodes: {
    codes: [],
    currentCode: null,
    validationResult: null,
    loading: false,
    error: null
  },
  // Toegangscodes overzicht state
  toegangsCodesOverzicht: []
};

export default function toegangscontroleReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_TOEGANGSCONTROLES:
      return {
        ...state,
        toegangscontroles: action.payload,
        loading: false,
        error: null
      };
      
    case FETCH_TOEGANGSCONTROLE:
      return {
        ...state,
        currentToegangscontrole: action.payload,
        loading: false,
        error: null
      };
      
    case SAVE_TOEGANGSCONTROLE:
      // Update bestaande of voeg nieuwe toe
      const updatedToegangscontroles = state.toegangscontroles.find(t => t._id === action.payload._id)
        ? state.toegangscontroles.map(t => t._id === action.payload._id ? action.payload : t)
        : [...state.toegangscontroles, action.payload];
        
      return {
        ...state,
        toegangscontroles: updatedToegangscontroles,
        currentToegangscontrole: action.payload,
        loading: false,
        error: null
      };
      
    case TOGGLE_TOEGANGSCONTROLE:
      return {
        ...state,
        toegangscontroles: state.toegangscontroles.map(t => 
          t._id === action.payload._id ? action.payload : t
        ),
        currentToegangscontrole: state.currentToegangscontrole?._id === action.payload._id 
          ? action.payload 
          : state.currentToegangscontrole,
        loading: false,
        error: null
      };
      
    case START_AUTHORIZATION:
      return {
        ...state,
        authorizationData: action.payload,
        loading: false,
        error: null
      };
      
    case REFRESH_TOKEN:
      // Update current config met nieuwe token info
      const refreshedConfig = state.currentToegangscontrole 
        ? { ...state.currentToegangscontrole, oauth_tokens: { ...state.currentToegangscontrole.oauth_tokens, ...action.payload } }
        : null;
        
      return {
        ...state,
        currentToegangscontrole: refreshedConfig,
        toegangscontroles: state.toegangscontroles.map(t => 
          t._id === refreshedConfig?._id ? refreshedConfig : t
        ),
        loading: false,
        error: null
      };
      
    case TEST_TOEGANGSCONTROLE:
      return {
        ...state,
        testResult: action.payload,
        loading: false,
        error: null
      };
      
    case TOEGANGSCONTROLE_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        testResult: null,
        authorizationData: null
      };

    // =============== DOORSY CASES ===============
    case FETCH_DOORSY_RESERVATIONS:
      return {
        ...state,
        doorsy: {
          ...state.doorsy,
          reservations: action.payload,
          loading: false,
          error: null
        }
      };

    case FETCH_DOORSY_RESERVATION:
      return {
        ...state,
        doorsy: {
          ...state.doorsy,
          currentReservation: action.payload,
          loading: false,
          error: null
        }
      };


    case SYNC_DOORSY_RESERVATIONS:
      return {
        ...state,
        doorsy: {
          ...state.doorsy,
          syncResult: action.payload,
          loading: false,
          error: null
        }
      };

    case TEST_DOORSY_CONNECTION:
      return {
        ...state,
        doorsy: {
          ...state.doorsy,
          connectionStatus: action.payload,
          loading: false,
          error: null
        }
      };

    case FETCH_DOORSY_USER_INFO:
      return {
        ...state,
        doorsy: {
          ...state.doorsy,
          userInfo: action.payload,
          loading: false,
          error: null
        }
      };

    case FETCH_DOORSY_SYSTEM_INFO:
      return {
        ...state,
        doorsy: {
          ...state.doorsy,
          systemInfo: action.payload,
          loading: false,
          error: null
        }
      };

    case FETCH_DOORSY_REALESTATES:
      return {
        ...state,
        doorsy: {
          ...state.doorsy,
          realestates: action.payload,
          loading: false,
          error: null
        }
      };

    case CREATE_DOORSY_REALESTATE:
      return {
        ...state,
        doorsy: {
          ...state.doorsy,
          realestates: [...state.doorsy.realestates, action.payload],
          loading: false,
          error: null
        }
      };

    case DOORSY_ERROR:
      return {
        ...state,
        doorsy: {
          ...state.doorsy,
          error: action.payload,
          loading: false
        }
      };

    // =============== TOEGANGSCODE CASES ===============
    case CREATE_TOEGANGSCODE:
      return {
        ...state,
        toegangscodes: {
          ...state.toegangscodes,
          codes: [action.payload, ...state.toegangscodes.codes],
          loading: false,
          error: null
        }
      };

    case FETCH_TOEGANGSCODES:
      return {
        ...state,
        toegangscodes: {
          ...state.toegangscodes,
          codes: action.payload,
          loading: false,
          error: null
        }
      };

    case FETCH_TOEGANGSCODE:
      return {
        ...state,
        toegangscodes: {
          ...state.toegangscodes,
          currentCode: action.payload,
          loading: false,
          error: null
        }
      };

    case DEACTIVEER_TOEGANGSCODE:
      return {
        ...state,
        toegangscodes: {
          ...state.toegangscodes,
          codes: state.toegangscodes.codes.map(code =>
            code._id === action.payload._id ? action.payload : code
          ),
          currentCode: state.toegangscodes.currentCode?._id === action.payload._id
            ? action.payload
            : state.toegangscodes.currentCode,
          loading: false,
          error: null
        }
      };

    case DELETE_TOEGANGSCODE:
      return {
        ...state,
        toegangscodes: {
          ...state.toegangscodes,
          codes: state.toegangscodes.codes.filter(code => code._id !== action.payload),
          currentCode: state.toegangscodes.currentCode?._id === action.payload
            ? null
            : state.toegangscodes.currentCode,
          loading: false,
          error: null
        }
      };

    case VALIDATE_TOEGANGSCODE:
      return {
        ...state,
        toegangscodes: {
          ...state.toegangscodes,
          validationResult: action.payload,
          loading: false,
          error: null
        }
      };

    case TOEGANGSCODE_ERROR:
      return {
        ...state,
        toegangscodes: {
          ...state.toegangscodes,
          error: action.payload,
          loading: false
        }
      };

    // =============== TOEGANGSCODES OVERZICHT CASES ===============
    case 'FETCH_TOEGANGSCODES_OVERZICHT_SUCCESS':
      return {
        ...state,
        toegangsCodesOverzicht: action.payload,
        loading: false,
        error: null
      };

    case 'CHECK_TOEGANGSCODE_STATUS_SUCCESS':
      // Update the specific code's status in the overview
      return {
        ...state,
        toegangsCodesOverzicht: state.toegangsCodesOverzicht.map(code =>
          code.doorsy?.uuid === action.payload.uuid
            ? {
                ...code,
                doorsy: {
                  ...code.doorsy,
                  api_response: action.payload.status,
                  actief_in_doorsy: action.payload.status.active !== false
                }
              }
            : code
        ),
        loading: false,
        error: null
      };

    default:
      return state;
  }
}